import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.shared-authenticators.delete', {
        url: '/delete',
        params: {accounts: []},
		//component: 'companySharingCenterSharedAuthenticatorsDelete',
		views: {
            '@company.sharing-center': 'companySharingCenterSharedAuthenticatorsDelete'
        },
        resolve: {
            accounts,
			companyId
        },
    });
}

/** @ngInject */
function accounts($stateParams) {
    return $stateParams.accounts;
}

/** @ngInject */
function companyId($stateParams) {
    return $stateParams.companyId;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-authenticators/delete/delete-accounts.state.js